import cn from "app/utils/classnames";

interface HeaderProps {
  className?: string | undefined;
  children: React.ReactNode;
}

export default function Header(props: HeaderProps) {
  return (
    <h1
      className={cn(
        "bg-black h-auto rounded-sm",
        "w-full",
        "py-3",
        "text-white text-center text-xl font-bold",
        "flex items-center justify-center leading-none",
        props.className
      )}
    >
      {props.children}
    </h1>
  );
}
